import byId from './byId';

export default byId;
